export enum GoogleDeviceStatus {
  ACTIVE = 'ACTIVE',
  DELINQUENT = 'DELINQUENT',
  DEPROVISIONED = 'DEPROVISIONED',
  DISABLED = 'DISABLED',
  INACTIVE = 'INACTIVE',
  RETURN_ARRIVED = 'RETURN_ARRIVED',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  SHIPPED = 'SHIPPED',
  UNKNOWN = 'UNKNOWN',
  PRE_PROVISIONED = 'PRE_PROVISIONED',
  PRE_PROVISIONED_DISABLED = 'PRE_PROVISIONED_DISABLED',
}